"use client";

import React, { useContext } from "react";
import "@/app/presse/Presse.css";
import Link from "next/link";
import StickyWidget from "@/common/StickyWidget";
import { UserContext } from "@/context/ContextProvider";

function DatenschutzPageClient() {
  const { setIsCookiePopupOpen } = useContext(UserContext);

  return (
    <div className="Presse">
      <div className="Presse-wrapper">
        <nav className="Presse-nav">
          <Link href="/" className="transition">
            Startseite
          </Link>
        </nav>

        <div className="Presse-main secondary">
          <div className="Presse-left">
            <h1>Datenschutzerklärung</h1>
            <p>Hier finden Sie unsere aktuelle Datenschutzerklärung:</p>

            <a
              className="link"
              href="/datenschutzerklärung_autoeinfachlos.pdf"
              download
              target="_blank"
              rel="noreferrer"
            >
              Datenschutzerklärung
            </a>

            <p>Cookie einstellung aktualisieren:</p>

            <p className="link" onClick={() => setIsCookiePopupOpen(true)}>
              Cookie einstellungen
            </p>
          </div>

          <div className="Presse-right">
            <StickyWidget />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DatenschutzPageClient;

